import { api } from './api';
import { ContactInsights } from 'Models/contact-insights';
import { ContactInsightsResult } from 'Models/contact-insights-result';

export const contactInsightsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getContactInsights: build.mutation<
      ContactInsightsResult,
      { companyId: string; params: ContactInsights }
    >({
      query({ companyId, params }) {
        return {
          url: `integration/core/company/${companyId}/insights/contacts`,
          method: 'POST',
          body: params,
        };
      },
      invalidatesTags: ['ContactInsights'],
    }),

  }),
});

export const {
  useGetContactInsightsMutation,
} = contactInsightsApi;